import * as TYPE from './actionType.js';

export function deliveryReturnData(deliveryReturnData) {
  return { type: TYPE.DELIVERYRETURNDATA, data: deliveryReturnData };
}
